import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';

@Component({
  selector: 'app-sgzp-app4-forgot-password',
  templateUrl: './sgzp-app4-forgot-password.component.html',
  styleUrls: [
    '../style/global.css',
    './sgzp-app4-forgot-password.component.css',
  ],
})
export class SgzpApp4ForgotPasswordComponent
  extends BaseLoginComponent
  implements OnInit {
  async init(): Promise<void> { }
}
